import { Tabs } from "@ofqual/portal-components/components/Tabs";
import { useHistory } from "react-router-dom";
import { UserRole } from "../../domain/userRole";
import { UserType } from "../../redux/types";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../../redux/selectors";

export const ListTabs: React.FC = () => {
  const { push } = useHistory();
  const { isInRole, userType } = useAuth(authSelector);

  const canDisplayEnTab = isInRole(
    UserRole.ITAdmin,
    UserRole.OfqualEventNotificationsAdmin,
    UserRole.AOEventNotificationsAdmin,
    UserRole.CCEAEventNotificationsAdmin,
    UserRole.AOAdmin
  );

  const canDisplayCaoTab = userType !== UserType.CCEA;

  const allTabs = [
    {
      id: "contact-the-regulator",
      label: "Contact the Regulator",
      dataTest: "inbox-ctr-tab",
    },
    {
      id: "event-notifications",
      label: "Event Notifications",
      dataTest: "inbox-en-tab",
    },
    { id: "contact-ao", label: "Contact AO", dataTest: "inbox-cao-tab" },
  ];

  const getFilteredTabs = () => {
    let tempFiltered = allTabs;
    if (!canDisplayEnTab)
      tempFiltered = tempFiltered.filter((x) => x.id !== "event-notifications");
    if (!canDisplayCaoTab)
      tempFiltered = tempFiltered.filter((x) => x.id !== "contact-ao");
    return [...tempFiltered];
  };

  const tabs = getFilteredTabs();

  return (
    <Tabs
      tabs={tabs}
      currentTabId={"contact-ao"}
      onTabChange={(newId) => push(newId)}
      dataTest="inbox-tabs"
    />
  );
};
